<script lang="ts">
    import { getSeiten } from "../../api"
    import { sprache } from "../../store"
    import LadeAnimation from "../LadeAnimation.svelte"
    import NewsTeaser from "../NewsTeaser.svelte"

    let ladeNews = true
    let items: Seite[] = []

    getSeiten($sprache, null, "news", null, "list", null, "-meta.datum").then(
        (r: Seite[]) => {
            items = r
            ladeNews = false
        }
    )
</script>

{#if ladeNews}
    <LadeAnimation />
{:else}
    <div class="collection">
        {#each items as news}
            <NewsTeaser news="{news}" />
        {/each}
    </div>
{/if}
